(() => {
  let refreshTimer;
  let observer;

  const cartUrl = () => `${window.Shopify?.routes?.root || '/'}cart.js`;

  function makePartChip(sku, quantity) {
    const chip = document.createElement('span');
    chip.className = 'cpp-cart-head__part';

    const strong = document.createElement('strong');
    strong.textContent = sku;
    chip.appendChild(strong);

    const qty = document.createElement('span');
    qty.textContent = `× ${quantity}`;
    chip.appendChild(qty);
    return chip;
  }

  function updateHeading(cart) {
    const count = document.querySelector('.cpp-cart-head__count');
    if (count) {
      count.textContent = '';
      const strong = document.createElement('strong');
      strong.textContent = cart.item_count;
      count.appendChild(strong);
      count.append(` item${cart.item_count === 1 ? '' : 's'}`);
    }

    const parts = document.querySelector('.cpp-cart-head__parts');
    if (parts) {
      parts.textContent = '';
      cart.items.forEach((item) => {
        if (item.sku) parts.appendChild(makePartChip(item.sku, item.quantity));
      });
    }
  }

  function updateRows(cart) {
    const rows = document.querySelectorAll('#main-cart-items .cart-item');
    rows.forEach((row, index) => {
      const details = row.querySelector('.cart-item__details');
      if (!details) return;

      const sku = cart.items[index]?.sku || '';
      let skuLine = details.querySelector('.cpp-cart-line-sku');

      if (!sku) {
        skuLine?.remove();
        return;
      }

      if (!skuLine) {
        skuLine = document.createElement('div');
        skuLine.className = 'cpp-cart-line-sku';
        const title = details.querySelector('.cart-item__title');
        if (title) title.insertAdjacentElement('afterend', skuLine);
        else details.prepend(skuLine);
      }

      skuLine.textContent = '';
      const label = document.createElement('span');
      label.textContent = 'Part no.';
      const value = document.createElement('strong');
      value.textContent = sku;
      skuLine.append(label, value);
    });
  }

  async function refreshCartDetails() {
    try {
      const response = await fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      observer?.disconnect();
      try {
        updateHeading(cart);
        updateRows(cart);
      } finally {
        observeCart();
      }
    } catch (_) {
      // Leave Shopify's standard cart UI working if this enhancement cannot refresh.
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCartDetails, 180);
  }

  function observeCart() {
    const target = document.getElementById('main-cart-items');
    if (!target) return;
    observer?.disconnect();
    observer = new MutationObserver(scheduleRefresh);
    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    refreshCartDetails();
    observeCart();
    document.addEventListener('change', (event) => {
      if (event.target.closest('#main-cart-items')) scheduleRefresh();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
